export const LandrBrand = 'LANDR';
export const SamplesBrand = 'Samples';
export const LandrSamplesBrand = `${LandrBrand} ${SamplesBrand}`;
export const CreatorBrand = 'Creator';
export const StudioPlan = 'Studio';
export const SamplesProPlan = `${SamplesBrand} Pro`;
export const SelectorBrand = 'Selector';
export const QuicksPicksBrand = 'Quick Picks';
